import { ISalesRepActions, SalesRepContext } from './actions.types';
import { IUserData } from '@/models';

export const actions: ISalesRepActions = {
  fetchSalesReps(context: SalesRepContext): Promise<void> {
    return this.$services.salesRep
      .fetchSalesReps()
      .then((salesReps: IUserData[]) => {
        context.commit('SET_SALES_REPS', salesReps);
      });
  },

  fetchSalesRep(context: SalesRepContext, payload: number): Promise<void> {
    return this.$services.salesRep
      .fetchSalesRep(payload)
      .then((salesRep: IUserData) => {
        const index = context.state.salesReps.findIndex(
          (v: IUserData) => v.id === salesRep.id
        );
        if (index === -1) {
          context.commit('ADD_SALES_REP', salesRep);
        } else {
          context.commit('UPDATE_SALES_REP', salesRep);
        }
      });
  }
};
